var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.activeTab,
            callback: function($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab"
          }
        },
        [
          _c("el-tab-pane", {
            attrs: { label: this.$t("邮箱配置"), name: "config" }
          }),
          _c("el-tab-pane", {
            attrs: { label: this.$t("邮箱模板"), name: "template" }
          }),
          _c("el-tab-pane", {
            attrs: { label: this.$t("邮箱查询"), name: "email" }
          }),
          _c("el-tab-pane", {
            attrs: { label: this.$t("设备列表"), name: "device" }
          })
        ],
        1
      ),
      _vm.activeTab === "config"
        ? _c(
            "div",
            { staticClass: "content-card" },
            [
              _c(
                "el-form",
                {
                  staticClass: "config-form",
                  attrs: { model: _vm.emailConfig, "label-width": "120px" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Email" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.emailConfig.email,
                          callback: function($$v) {
                            _vm.$set(_vm.emailConfig, "email", $$v)
                          },
                          expression: "emailConfig.email"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Email Host" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.emailConfig.smtpHost,
                          callback: function($$v) {
                            _vm.$set(_vm.emailConfig, "smtpHost", $$v)
                          },
                          expression: "emailConfig.smtpHost"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Email Port" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.emailConfig.smtpPort,
                          callback: function($$v) {
                            _vm.$set(_vm.emailConfig, "smtpPort", $$v)
                          },
                          expression: "emailConfig.smtpPort"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Email Password" } },
                    [
                      _c("el-input", {
                        attrs: { type: "password" },
                        model: {
                          value: _vm.emailConfig.email_password,
                          callback: function($$v) {
                            _vm.$set(_vm.emailConfig, "email_password", $$v)
                          },
                          expression: "emailConfig.email_password"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.saveConfig }
                        },
                        [_vm._v(_vm._s(this.$t("保存配置")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.activeTab === "template"
        ? _c(
            "div",
            { staticClass: "content-card" },
            [
              _c(
                "div",
                { staticClass: "template-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addTemplate }
                    },
                    [_vm._v(_vm._s(this.$t("新增模板")))]
                  )
                ],
                1
              ),
              _c(
                "el-table",
                {
                  staticClass: "template-list",
                  attrs: { data: _vm.templateList, stripe: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "email_language",
                      label: this.$t("邮箱语言")
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "email_title", label: this.$t("邮件主题") }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "email_template",
                      label: this.$t("邮箱内容")
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("div", { staticClass: "ellipsis-text" }, [
                                _vm._v(_vm._s(scope.row.email_template))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      55243921
                    )
                  }),
                  _c("el-table-column", {
                    attrs: { label: this.$t("操作"), width: "180" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.editTemplate(scope.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("编辑")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "danger" },
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteTemplate(scope.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("删除")))]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      773527365
                    )
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "footer" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.templateCurrentPage,
                      "page-sizes": [5, 10, 20, 50],
                      "page-size": _vm.templatePageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.templateTotal
                    },
                    on: {
                      "size-change": _vm.handleTemplateSizeChange,
                      "current-change": _vm.handleTemplateCurrentChange
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.activeTab === "email"
        ? _c(
            "div",
            { staticClass: "content-card" },
            [
              _c(
                "el-form",
                {
                  staticClass: "demo-form-inline",
                  attrs: { inline: true, model: _vm.queryForm }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: this.$t("用户邮箱") } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: this.$t("用户邮箱") },
                        model: {
                          value: _vm.queryForm.user_email,
                          callback: function($$v) {
                            _vm.$set(_vm.queryForm, "user_email", $$v)
                          },
                          expression: "queryForm.user_email"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: this.$t("邮箱类型") } },
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.queryForm.email_type,
                            callback: function($$v) {
                              _vm.$set(_vm.queryForm, "email_type", $$v)
                            },
                            expression: "queryForm.email_type"
                          }
                        },
                        _vm._l(_vm.emailTypeList, function(item) {
                          return _c("el-option", {
                            key: item.dict_label,
                            attrs: {
                              label: item.dict_label,
                              value: item.dict_label
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: this.$t("日期范围") } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "range-separator": this.$t("至"),
                          "start-placeholder": this.$t("开始日期"),
                          "end-placeholder": this.$t("结束日期")
                        },
                        model: {
                          value: _vm.queryForm.dateRange,
                          callback: function($$v) {
                            _vm.$set(_vm.queryForm, "dateRange", $$v)
                          },
                          expression: "queryForm.dateRange"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onQuery }
                        },
                        [_vm._v(_vm._s(this.$t("search")))]
                      ),
                      _c("el-button", { on: { click: _vm.resetQuery } }, [
                        _vm._v(_vm._s(this.$t("reset")))
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-table",
                {
                  staticClass: "email-list",
                  attrs: { data: _vm.emailList, stripe: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "user_email",
                      label: this.$t("用户邮箱"),
                      width: "180"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "email_title", label: this.$t("标题") }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: this.$t("邮箱内容"),
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("div", { staticClass: "ellipsis-text" }, [
                                _vm._v(_vm._s(scope.row.email_template))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      55243921
                    )
                  }),
                  _c("el-table-column", {
                    attrs: { label: this.$t("操作"), width: "180" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.showDetail(
                                        scope.row.email_template
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("查看")))]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2671374589
                    )
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "footer" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.currentPage,
                      "page-sizes": [10, 20, 50, 100],
                      "page-size": _vm.pageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.total
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.activeTab === "device"
        ? _c(
            "div",
            { staticClass: "content-card" },
            [
              _c(
                "el-table",
                {
                  staticClass: "device-list",
                  attrs: { data: _vm.deviceList, stripe: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "device_number",
                      label: this.$t("device_number")
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "device_name",
                      label: this.$t("device_name")
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "device_address",
                      label: this.$t("device_address")
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "email_send", label: this.$t("邮件发送") },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: scope.row.email_send
                                      ? "success"
                                      : "danger"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        scope.row.email_send
                                          ? _vm.$t("开启")
                                          : _vm.$t("关闭")
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3373945761
                    )
                  }),
                  _c("el-table-column", {
                    attrs: { label: this.$t("操作"), width: "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.editDevice(scope.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("编辑")))]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2691307727
                    )
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "footer" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.deviceCurrentPage,
                      "page-sizes": [5, 10, 20, 50],
                      "page-size": _vm.devicePageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.deviceTotal
                    },
                    on: {
                      "size-change": _vm.handleDeviceSizeChange,
                      "current-change": _vm.handleDeviceCurrentChange
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: this.$t("setting"),
            visible: _vm.deviceDialogVisible,
            width: "50%"
          },
          on: {
            "update:visible": function($event) {
              _vm.deviceDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              staticClass: "device-form",
              attrs: { model: _vm.currentDevice, "label-width": "120px" }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: this.$t("device_number") } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.currentDevice.device_number,
                      callback: function($$v) {
                        _vm.$set(_vm.currentDevice, "device_number", $$v)
                      },
                      expression: "currentDevice.device_number"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: this.$t("device_name") } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.currentDevice.device_name,
                      callback: function($$v) {
                        _vm.$set(_vm.currentDevice, "device_name", $$v)
                      },
                      expression: "currentDevice.device_name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: this.$t("device_address") } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.currentDevice.device_address,
                      callback: function($$v) {
                        _vm.$set(_vm.currentDevice, "device_address", $$v)
                      },
                      expression: "currentDevice.device_address"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: this.$t("邮件发送") } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-color": "#13ce66",
                      "inactive-color": "#ff4949",
                      "active-text": _vm.$t("开启"),
                      "inactive-text": _vm.$t("关闭")
                    },
                    model: {
                      value: _vm.currentDevice.email_send,
                      callback: function($$v) {
                        _vm.$set(_vm.currentDevice, "email_send", $$v)
                      },
                      expression: "currentDevice.email_send"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.deviceDialogVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(this.$t("cancel")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.updateDevice } },
                [_vm._v(_vm._s(this.$t("save")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: this.$t("新建邮箱模板"),
            visible: _vm.createDialogVisible,
            width: "70%"
          },
          on: {
            "update:visible": function($event) {
              _vm.createDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              staticClass: "template-form",
              attrs: { model: _vm.newTemplate, "label-width": "120px" }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "email_keys" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.newTemplate.email_keys,
                      callback: function($$v) {
                        _vm.$set(_vm.newTemplate, "email_keys", $$v)
                      },
                      expression: "newTemplate.email_keys"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "email_title" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.newTemplate.email_title,
                      callback: function($$v) {
                        _vm.$set(_vm.newTemplate, "email_title", $$v)
                      },
                      expression: "newTemplate.email_title"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "email_language" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.newTemplate.email_language,
                        callback: function($$v) {
                          _vm.$set(_vm.newTemplate, "email_language", $$v)
                        },
                        expression: "newTemplate.email_language"
                      }
                    },
                    _vm._l(_vm.langList, function(item) {
                      return _c("el-option", {
                        key: item.dict_label,
                        attrs: {
                          label: item.dict_label,
                          value: item.dict_label
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "email_type" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.newTemplate.email_type,
                        callback: function($$v) {
                          _vm.$set(_vm.newTemplate, "email_type", $$v)
                        },
                        expression: "newTemplate.email_type"
                      }
                    },
                    _vm._l(_vm.emailTypeList, function(item) {
                      return _c("el-option", {
                        key: item.dict_label,
                        attrs: {
                          label: item.dict_label,
                          value: item.dict_label
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "email_template" } },
                [
                  _c("d2-quill", {
                    model: {
                      value: _vm.newTemplate.email_template,
                      callback: function($$v) {
                        _vm.$set(_vm.newTemplate, "email_template", $$v)
                      },
                      expression: "newTemplate.email_template"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.createDialogVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(this.$t("cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveNewTemplate }
                },
                [_vm._v(_vm._s(this.$t("save")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: this.$t("编辑邮箱模板"),
            visible: _vm.editDialogVisible,
            width: "70%"
          },
          on: {
            "update:visible": function($event) {
              _vm.editDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              staticClass: "template-form",
              attrs: { model: _vm.currentTemplate, "label-width": "120px" }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "email_keys" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.currentTemplate.email_keys,
                      callback: function($$v) {
                        _vm.$set(_vm.currentTemplate, "email_keys", $$v)
                      },
                      expression: "currentTemplate.email_keys"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "email_title" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.currentTemplate.email_title,
                      callback: function($$v) {
                        _vm.$set(_vm.currentTemplate, "email_title", $$v)
                      },
                      expression: "currentTemplate.email_title"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "email_language" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.currentTemplate.email_language,
                        callback: function($$v) {
                          _vm.$set(_vm.currentTemplate, "email_language", $$v)
                        },
                        expression: "currentTemplate.email_language"
                      }
                    },
                    _vm._l(_vm.langList, function(item) {
                      return _c("el-option", {
                        key: item.dict_label,
                        attrs: {
                          label: item.dict_label,
                          value: item.dict_label
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "email_type" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.currentTemplate.email_type,
                        callback: function($$v) {
                          _vm.$set(_vm.currentTemplate, "email_type", $$v)
                        },
                        expression: "currentTemplate.email_type"
                      }
                    },
                    _vm._l(_vm.emailTypeList, function(item) {
                      return _c("el-option", {
                        key: item.dict_label,
                        attrs: {
                          label: item.dict_label,
                          value: item.dict_label
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "email_template" } },
                [
                  _c("d2-quill", {
                    model: {
                      value: _vm.currentTemplate.email_template,
                      callback: function($$v) {
                        _vm.$set(_vm.currentTemplate, "email_template", $$v)
                      },
                      expression: "currentTemplate.email_template"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.editDialogVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(this.$t("cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.updateTemplate }
                },
                [_vm._v(_vm._s(this.$t("save")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: this.$t("detail"),
            visible: _vm.detailDialogVisible,
            width: "60%"
          },
          on: {
            "update:visible": function($event) {
              _vm.detailDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "detail-content" }, [
            _vm._v(_vm._s(_vm.currentDetailContent))
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.detailDialogVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(this.$t("关闭")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }